module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/landprocurement.component.css
// module id = ./src/app/landprocurement/landprocurement.component.css
// module chunks = main